import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daeo0mbep053ijub1eu0";

type Status =
  | { type: "idle" }
  | { type: "loading" }
  | { type: "success" }
  | { type: "error"; msg: string };

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>({ type: "idle" });

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);

    const honeypot = String(fd.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus({ type: "success" });
      return;
    }

    const payload = new FormData();
    const realEmail = fd.get("email");
    if (realEmail) payload.append("email", String(realEmail));
    payload.delete("website_alt");

    setStatus({ type: "loading" });
    try {
      const res = await fetch(SUBMIT_URL, { method: "POST", body: payload });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const isOk = res.ok && code === "OK";

      if (isOk) {
        setStatus({ type: "success" });
        setEmail("");
      } else {
        setStatus({
          type: "error",
          msg:
            serverMsg ||
            "订阅失败，请稍后重试或核对邮箱后再次提交。",
        });
      }
    } catch {
      setStatus({ type: "error", msg: "网络异常，订阅失败，请稍后重试。" });
    }
  }

  return (
    <form
      id="daily-newsletter-form"
      data-readdy-form="daily-newsletter-form"
      onSubmit={handleSubmit}
      className="mx-auto w-full max-w-2xl"
    >
      <label className="mb-3 block text-center text-sm text-background-100/90">
        留下邮箱，每天为你送上最新独家内幕与深度吃瓜选题。
      </label>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-0 sm:rounded-full sm:border sm:border-background-100/30 sm:bg-background-50 sm:p-1.5">
        <div className="flex flex-1 items-center gap-2 rounded-full border border-background-100/30 bg-background-50 px-4 sm:border-0">
          <i className="ri-mail-line text-foreground-400" />
          <input
            type="email"
            name="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱"
            autoComplete="email"
            className="w-full bg-transparent py-3 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 sm:py-2.5"
          />
        </div>
        <button
          type="submit"
          disabled={status.type === "loading"}
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:bg-accent-400 disabled:opacity-70 sm:py-2.5"
        >
          {status.type === "loading" ? (
            <>
              <i className="ri-loader-4-line animate-spin" /> 提交中
            </>
          ) : (
            <>
              <i className="ri-send-plane-fill" /> 立即订阅
            </>
          )}
        </button>
      </div>
      {/* 反垃圾蜜罐 */}
      <input
        type="text"
        name="website_alt"
        className="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />
      {status.type === "success" && (
        <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-sm text-accent-300">
          <i className="ri-checkbox-circle-fill" />
          订阅成功！欢迎加入今日新瓜的瓜友行列。
        </p>
      )}
      {status.type === "error" && (
        <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-sm text-accent-300">
          <i className="ri-error-warning-fill" />
          {status.msg}
        </p>
      )}
    </form>
  );
}